<template>
  <div class="map-container">
    <img class="high-light" src="../../public//images/high-light.png" alt="" />
    <img class="circle" src="../../public/images/m-circle.png" alt="" />

    <div class="map-box" ref="mapChartRef"></div>
  </div>
</template>

<script>
import mapJson from '@/assets/data/daguan.json';
import mapAreaImg from '../../public/images/map-area-bg.png';

export default {
  name: 'MapChart',
  components: {},
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  watch:{
    items: {
      handler(val) {
        if (val.length > 0) {
          this.mapData = val;
          this.initChart();
        }
      },
      deep: true
    }
  },

  data() {
    return {
      chartInstance: null,
      mapData: [],
      mapJson,
      currentIndex: 0,
      intervalId: null,

      option: {
        title: { show: false },
        tooltip: {
          trigger: 'item',
        },
        geo: [
          {
            map: 'mapJson',
            zoom: 1.1,
            aspectScale: 1,
            layoutCenter: ['50%', '50%'],
            roam: false,
            label: {
              show: false,
            },
            itemStyle: {
              areaColor: {
                image: mapAreaImg, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: 'no-repeat',
              },
              // borderColor: '#437fe1',
            },
            emphasis: {
              disabled: true,
            },
            select: {
              disabled: true,
            },
          },

          // 重影
          {
            type: 'map',
            map: 'mapJson',
            zlevel: -1,
            aspectScale: 1,
            zoom: 1.1,
            layoutCenter: ['50%', '51%'],
            layoutSize: '80%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 2,
              borderColor: '#16a388',
              shadowColor: 'rgba(172, 122, 255,0.5)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'rgba(5,21,35,0.1)',
            },
          },
          {
            type: 'map',
            map: 'mapJson',
            zlevel: -2,
            aspectScale: 1,
            zoom: 1.1,
            layoutCenter: ['50%', '52%'],
            layoutSize: '80%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(22,163,1361,0.6)',
              shadowColor: 'rgba(22,163,136,1)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'transpercent',
            },
          },
          {
            type: 'map',
            map: 'mapJson',
            zlevel: -3,
            aspectScale: 1,
            zoom: 1.1,
            layoutCenter: ['50%', '53%'],
            layoutSize: '80%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(22,163,136,0.4)',
              shadowColor: 'rgba(22,163,136,1)',
              shadowOffsetY: 15,
              shadowBlur: 8,
              areaColor: 'transpercent',
            },
          },
        ],

        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            geoIndex: 0,
            itemStyle: {
              color: '#1af5c3',
            },

            selectedMode: true,
            select: {
              itemStyle: {
                color: '#000000',
              },
            },

            label: {
              show: false,
              formatter: function (params, ticket, callback) {
                return params.data[2].townName;
              },
              position: 'top',
              color: '#ffffff',
              fontSize: 12,
            },
            data: [
              // [103.768236, 27.586383, { townName: '靖安镇', plarea: 0.68, bambooShoots: 60, bambooWood: 1950 }],
              // [103.781392, 27.643749, { townName: '上高桥乡', plarea: 1.07, bambooShoots: 81, bambooWood: 1050 }],
              // [103.871634, 27.6908, { townName: '玉碗镇', plarea: 7.84, bambooShoots: 1497, bambooWood: 44180 }],
              // [103.874504, 27.753423, { townName: '翠华镇', plarea: 11.89, bambooShoots: 6069, bambooWood: 74060 }],
              // [103.753743, 27.810808, { townName: '悦乐镇', plarea: 5.44, bambooShoots: 1158, bambooWood: 26450 }],
              // [103.955117, 27.832366, { townName: '天星镇', plarea: 18.37, bambooShoots: 10019, bambooWood: 89080 }],
              // [103.907339, 27.907706, { townName: '寿山镇', plarea: 15.42, bambooShoots: 1964, bambooWood: 13680 }],
              // [103.977976, 27.999599, { townName: '吉利镇', plarea: 7.61, bambooShoots: 2832, bambooWood: 38880 }],
              // [103.897321, 28.036548, { townName: '高桥镇', plarea: 17.95, bambooShoots: 3636, bambooWood: 63840 }],
              // [103.944786, 28.123942, { townName: '木杆镇', plarea: 30.33, bambooShoots: 25583, bambooWood: 210830 }],
            ],
            rippleEffect: {
              // 涟漪特效相关配置
              number: 3, // 波纹的数量
              period: 4, // 动画的周期，秒数
              scale: 3, //波纹的最大缩放比例。
              brushType: 'stroke', // 波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            tooltip: {
              trigger: 'item',
              backgroundColor: '#132933',
              borderColor: '#17c09c',
              borderWidth: 2,
              padding: [10, 20],
              textStyle: {
                color: '#ffffff',
              },
              formatter: function (params, ticket, callback) {
                let htmlStr = `
                  <div>
                    <p style="font-size: 16px;padding-bottom: 10px">${params.data[2].title}</p>
                `;
                params.data[2].data.forEach((item) => {
                  htmlStr += `<p style="height:30px;line-height:30px;">${item.title}：<b style="color:#1beaba;padding-right:6px;font-size:16px;">${item.data}</b>${item.unit}</p>`;
                });
                htmlStr += `</div>`
                return htmlStr;
              },
            },
          },
        ],
      },
    };
  },
  created() {},
  mounted() {

  },
  methods: {
    initChart() {
      this.$echarts.registerMap('mapJson', mapJson);
      let chartRef = this.$refs.mapChartRef;
      if (this.chartInstance) {
        this.chartInstance.dispose(); // 销毁已有实例
      }
      this.chartInstance = this.$echarts.init(chartRef);

      this.resolveMapData(this.mapData)
      if(this.option) {
        this.chartInstance.setOption(this.option, true);
      }
      // 清除现有间隔
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // 设置新间隔
      this.intervalId = setInterval(() => {
        // 显示当前城市的tooltip
        this.chartInstance.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.currentIndex,
          position: 'top',
        });
        // 更新当前索引
        this.currentIndex = (this.currentIndex + 1) % this.option.series[0].data.length;
      }, 3000); // 每3秒切换一次
    },
    /**
     * 处理mapData
     */
     resolveMapData(mapData) {
      if (!mapData || mapData.length === 0) return;
      let newData = [];
      mapData.forEach((item) => {
        if(item.localtion.length === 2) {
          newData.push([
            item.localtion[0],
            item.localtion[1],
            item
          ])
        }
      })
      this.option.series[0].data = newData;
    },

  },
};
</script>

<style lang="scss" scoped>
.map-container {
  flex: 1;
  background: url('../../public/images/map-bg.png') center no-repeat;
  background-size: 140% 140%;
  position: relative;

  .high-light {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
  }
  .circle {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 3;
    width: 85%;
    animation: rotate 8s linear infinite;
  }
  .map-box {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 4;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
